<template>
  <div>
     
    <section v-show="showEditor" class="clearfix">
       
       <b-form @submit.prevent="submit" >
        <vue-editor id="noteEditor" :editor-toolbar="customToolbar"  v-model="note" ></vue-editor>
        <b-button variant="info" type="submit"  class="pull-right m-t-10" :disabled="!this.note">
           <b-spinner small v-if="processing"></b-spinner>
           <b-icon icon="arrow-right" v-else></b-icon>
        </b-button>
       </b-form>
    </section>
  </div>
</template>

<script>
import { VueEditor  } from "vue2-editor";
import NoteService from "../../services/note.service"
import EventBus from '../../EventBus'
  export default {
     data(){
       return {
         note: "",
         id: null,
         customToolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["code-block", "link"]
          ],
          processing: false
       }
     },
     props: {
       showEditor: {
         type: Boolean
       },
       data: {
         type: Object,
         default: () => ({})
       }
     },
     mounted(){
       EventBus.$on("note-closed", () => {
          this.note = ''
       })

       EventBus.$on("edit-note", ({id, noteContent}) => {
          this.note = noteContent;
          this.id = id;
       })
     },
     methods: {
       async submit(){
          let result;
          try{
              if(this.note){
             let data = {
                ...this.data,
                noteContent: this.note
             }
             this.processing = true;
             if(!this.id){
               
               result = await NoteService.addNote(data);
             }
             else{

               result = await NoteService.updateNote(data, this.id);
               
             }


            this.$toasted.show(
              result.data.message,
              {
                type: "success",
                duration: 3000,
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
              }
            );

             this.processing = false;

            console.log("note added")
            
            EventBus.$emit('added-or-edited-note', {noteType: this.data.noteType, recordId: this.data.recordId});
            this.note = ''
          }
          }
          catch(errors){
            console.log(errors.response);

            this.$toasted.show(
              errors.response.data.message,
              {
                type: "error",
                duration: 3000,
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
              }
            );
            this.processing = false;
          }
          this.id = null;
      }
     },
     components: {VueEditor}
  }
</script>

<style lang="scss" scoped>

</style>